import { useState, useEffect } from 'react';
import axios from 'axios';
import '../../theme/core.css'
// import { Link, useHistory } from 'react-router-dom';
import ImageCard from './imageCard'
// import ReactLoading from 'react-loading';
import { ProfileAboutStyledH2, SmallContainer } from '../../styledComponents/globalStyled'
import { getProjects } from 'utils/requestsJSON';


export default function PlainGames() {
    // console.log(process.env.REACT_APP_API_URL)
    const [items, setItems] = useState<any>([]);
    useEffect(() => {
        let data = getProjects();
        setItems(data);
        // axios.get(`${process.env.REACT_APP_API_URL}projects/games`)
        //     .then(res => {
        //         // console.log(res.data);
        //         const result = res.data;
        //         setItems(result);
        //     })
    }, []);

    return (
        <>

            <ProfileAboutStyledH2 id="Gallery">All 2D and 3D Games</ProfileAboutStyledH2>
            <ul>

                {(items.length < 1) ?
                    <SmallContainer>
                        {/* <ReactLoading type='bubbles' color='black' height={25} width={50} /> */}
                    </SmallContainer> :
                    <SmallContainer>
                        {items.map((item: any, index: any) => {
                            if (item.tags !== "VR") { return <ImageCard info={item} key={index} /> } return null
                        })}
                    </SmallContainer>}

            </ul>
        </>
    );
}
